import {
  hasAdminAccess,
  hasClientSystemAdminAccess,
  hasSystemAdminAccess,
} from './accessChecks';

import { Role } from '../types/enums/Role.enum';
import { IUser } from '../types/interfaces';

export const rolesAllowedInOrgGroups = [
  Role.OrgGroupAdministrator,
  Role.OrgGroupUser,
];

export function isRoleAllowedInGroup(role: Role): boolean {
  return rolesAllowedInOrgGroups.includes(role);
}

export function userCanEditOrgGroups(role: Role): boolean {
  return [Role.SystemAdministrator, Role.ClientSystemAdministrator].includes(
    role,
  );
}

export function getFieldsAllowedToEdit(role: Role): string[] {
  // Users are allowed to edit their personal info
  const allowedFieldNames: (keyof IUser)[] = [
    'name',
    'title',
    'phone',
    'alertPreferences',
    'alertsViewedAt',
  ];

  // Administrators are allowed to deactivate users and change the role
  if (hasAdminAccess(role)) {
    allowedFieldNames.push('isActive', 'userType');
  }

  // Client System Administrators can assign users to organizations
  if (hasClientSystemAdminAccess(role)) {
    allowedFieldNames.push('organizationId');
  }

  return allowedFieldNames;
}

export function getRolesAllowedToEdit(role: Role): Role[] {
  // Non administrators cannot edit other user roles.
  if (!hasAdminAccess(role)) {
    return [];
  }

  // Administrators are allowed to create users with Administrator, ReadOnly, and User roles
  const allowedRoles = [Role.ReadOnly, Role.User, Role.Administrator];

  // Client System Administrators are allowed to additionally create users with ClientSystemAdministrator,
  // OrgGroupAdministrator, and OrgGroupUser rolls
  if (hasClientSystemAdminAccess(role)) {
    allowedRoles.push(
      Role.OrgGroupUser,
      Role.OrgGroupAdministrator,
      Role.ClientSystemAdministrator,
    );
  }

  // System Aministrators are allowed to additonally create users with the SystemAdministrator rolls
  if (hasSystemAdminAccess(role)) {
    allowedRoles.push(Role.SystemAdministrator);
  }

  return allowedRoles;
}
